import { IContactList } from '@/types';
import { getUrl } from '@/utils/api';

function useContactLists(filter?: string) {
  let url = `v1/contact_lists`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as IContactList[],
  };
}

export default useContactLists;
